import { SubscriptionPauseUnusedPeriodType } from '@data/enums';

const subscriptionPauseUnusedPeriodTypeInformation: { [type in SubscriptionPauseUnusedPeriodType]: string } = {
    [SubscriptionPauseUnusedPeriodType.CALCULATE_AUTOMATICALLY]: 'Calculate automatically',
    [SubscriptionPauseUnusedPeriodType.CUSTOM]: 'Custom unused period',
};

export default subscriptionPauseUnusedPeriodTypeInformation;
